var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "1em" } },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "cga-status" },
            [
              _c("b-icon", {
                attrs: { icon: "spinner", "custom-class": "fa-spin" }
              }),
              _c("span", [_vm._v(_vm._s(_vm.$t("cgu.loading")))])
            ],
            1
          )
        : _vm.loadError
        ? _c("div", { staticClass: "cga-status" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("cgu.error")) + "\n  ")
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading && !_vm.loadError,
              expression: "!loading && !loadError"
            }
          ],
          staticClass: "home_wrap"
        },
        [
          _c("div", { staticClass: "pdf-container" }, [
            _c("canvas", { ref: "pdfCanvas" })
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading && !_vm.loadError,
              expression: "!loading && !loadError"
            }
          ],
          staticClass: "controls"
        },
        [
          _c(
            "button",
            {
              attrs: { disabled: _vm.pageNum <= 1 },
              on: { click: _vm.prevPage }
            },
            [_vm._v(_vm._s(_vm.$t("cgu.previous")))]
          ),
          _c("span", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("cgu.page", {
                    current: _vm.pageNum,
                    total: _vm.numPages
                  })
                ) +
                " "
            )
          ]),
          _c(
            "button",
            {
              attrs: { disabled: _vm.pageNum >= _vm.numPages },
              on: { click: _vm.nextPage }
            },
            [_vm._v(_vm._s(_vm.$t("cgu.next")))]
          )
        ]
      ),
      _vm.isActive !== null
        ? _c(
            "b-field",
            { staticClass: "controls" },
            [
              _c(
                "b-button",
                {
                  attrs: { disabled: _vm.loading || _vm.loadError },
                  on: { click: _vm.accepteCGA }
                },
                [_vm._v(_vm._s(_vm.$t("cgu.accepter")))]
              ),
              _c("b-button", { on: { click: _vm.refuse } }, [
                _vm._v(_vm._s(_vm.$t("cgu.refuser")))
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }